import {toast, ToastCard} from '@sollapay/ui/components';

import type {FC, ReactElement} from 'react';

export interface ResultToastCardProps {
  toastId: string | number;
  isError: boolean;
  title: string;
  description: string;
  closeLabel: string;
  action?: {label: string; onClick: () => void};
}

/** Shared shell for every one-shot success/error toast — icon, `ToastCard` chrome, and dismiss wiring are identical everywhere; only the copy differs per action. */
export const ResultToastCard: FC<ResultToastCardProps> = ({
  toastId,
  isError,
  title,
  description,
  closeLabel,
  action
}) => (
  <ToastCard
    iconName={isError ? 'sollapay:close' : 'sollapay:check'}
    title={title}
    description={description}
    action={action}
    onClose={() => toast.dismiss(toastId)}
    closeLabel={closeLabel}
  />
);

/** Errors linger longer (10s) than success (6s) — the duration convention shared by every result toast. */
export function showResultToast(
  isError: boolean,
  render: (toastId: string | number) => ReactElement
): void {
  toast.custom(render, {duration: isError ? 10_000 : 6_000});
}

export function showResultToastCard(card: Omit<ResultToastCardProps, 'toastId'>): void {
  showResultToast(card.isError, id => <ResultToastCard toastId={id} {...card} />);
}
